import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchNumproducts({ commit, state }) {

      if (state.data)
        return;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/mainpage/products/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
        console.error('Error fetching:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    numproducts: state => state.data,
    numproductsLoading: state => state.loading,
    numproductsError: state => state.error,
    numproductsLoaded: state => state.loaded,
  }
})